import { Button } from "@/components/Button"
import { Autocomplete } from "@/components/Selector/Autocomplete"
import { DownloadIcon } from "@/components/two-factor/DownloadIcon"
import { BtnSearch } from "@/constants/SvgConstants"

import { IOption } from "@/types"
import { EURO_OPTION, IBANContext, USD_OPTION } from "@usher/pe-client-front-end-lib"
import { useContext, useState } from "react"
import DatePicker from "react-datepicker"
import { FormattedMessage, useIntl } from "react-intl"

interface Props {
  filter: Record<string, string>
  setFilter: (filter: Record<string, string>) => void
  onDownload: () => void
  range: [Date | null, Date | null]
  setRange: (range: [Date | null, Date | null]) => void
  onResultClick: () => void
  loading: boolean
}
const OPTIONS = {
  EUR: 1,
  USD: 3,
}
export const PaymentsTableFilter = ({ onDownload, loading, range, setRange, setFilter, onResultClick }: Props) => {
  const { setCurrencyFilter, currencyFilter } = useContext(IBANContext)
  const [period, setPeriod] = useState<IOption<string> | null>(null)

  const isCustom = period?.value === "1"
  const { $t: t, locale } = useIntl()
  return (
    <div className="payments-filter p-7 border-b ">
      <div className="flex justify-end gap-[10px] flex-col md:flex-row">
        <Autocomplete
          className="min-w-40"
          label={t({ id: "period" })}
          options={[{ value: "All", label: "All" }, EURO_OPTION, USD_OPTION]}
          onChange={(option) => {
            setCurrencyFilter(String(option?.value))
            // @ts-ignore
            setFilter({ ...filter, currency_fiat_id: option?.value.toLowerCase() === "all" ? void 0 : OPTIONS[option?.value] })
          }}
          // @ts-ignore
          value={currencyFilter != null ? { label: currencyFilter, value: currencyFilter } : { value: "0", label: "All" }}
        />
        <Autocomplete
          className="min-w-40"
          label={t({ id: "period" })}
          options={[
            { value: "0", label: "All time" },
            { value: "1", label: "Custom" },
          ]}
          onChange={(option) => {
            if (option?.value === "0") {
              // @ts-ignore
              setFilter({ ...filter, time_from: void 0, time_to: void 0 })
            }
            setPeriod(option)
          }}
          value={period ?? { value: "0", label: "All time" }}
        />
        {isCustom && (
          <DatePicker
            selectsRange
            selected={Array.isArray(range) ? range[0] : range}
            startDate={Array.isArray(range) ? range[0] : range}
            endDate={Array.isArray(range) ? range[1] : range}
            onChange={setRange}
            maxDate={new Date()}
            locale={locale}
            isClearable
            className="form-orders_item_date min-w-[250px] w-full max-w-[250px] [& input]:w-full"
          />
        )}
        <div className="flex flex-col sm:flex-row gap-2.5">
          <Button to="/iban/new-payment" className="flex-1 md:flex-auto">
            + New Payment
          </Button>
          <Button color="inherit" className="flex-1 md:flex-auto gap-2" onClick={onResultClick}>
            <BtnSearch />
            <FormattedMessage id="results" />
          </Button>
          <Button color="inherit" className="w-full min-w-0 sm:w-fit" onClick={onDownload} disabled={loading}>
            <DownloadIcon />
            <span className="inline-block sm:hidden ml-2">
              <FormattedMessage id="download" />
            </span>
          </Button>
        </div>
      </div>
    </div>
  )
}
